import React, { useState } from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"


export default ({ children, clrDarkest, clrDarker, clrDark, clrPrimary, clrLight, clrLighter, clrLightest }) => {

const [colourVisibility, setColourVisibility] = useState(false)

const showColour = () => {
  setColourVisibility(!colourVisibility)
  setTimeout(() => setColourVisibility(colourVisibility), 3000)
}
  return (
        <div className="clrBlk">
        <CopyToClipboard text={clrDarkest} onCopy={showColour}>
          <div style={{backgroundColor:clrDarkest}} className="clrItem clrDrkest">
            <span className="clrTxt">{`${colourVisibility ? "Colour Copied" : "Darkest" }`}</span>
            <span className="clrCnt">{clrDarkest}</span>
          </div>
        </CopyToClipboard>
        <CopyToClipboard text={clrDarker} onCopy={showColour}>
          <div style={{backgroundColor:clrDarker}} className="clrItem clrDarker">
            <span className="clrTxt">{`${colourVisibility ? "Colour Copied" : "Darker" }`}</span>
            <span className="clrCnt">{clrDarker}</span>
          </div>
        </CopyToClipboard>
        <CopyToClipboard text={clrDark}onCopy={showColour}>
          <div style={{backgroundColor:clrDark}} className="clrItem clrDark">
            <span className="clrTxt">{`${colourVisibility ? "Colour Copied" : "Dark" }`}</span>
            <span className="clrCnt">{clrDark}</span>
          </div>
        </CopyToClipboard>
        <CopyToClipboard text={clrPrimary} onCopy={showColour}>
          <div style={{backgroundColor:clrPrimary}} className="clrItem clrPrimary">
            <span className="clrTxt">{`${colourVisibility ? "Colour Copied" : "Primary" }`}</span>
            <span className="clrCnt">{clrPrimary}</span>
          </div>
        </CopyToClipboard>
        <CopyToClipboard text={clrLight} onCopy={showColour}>
          <div style={{backgroundColor:clrLight}} className="clrItem clrLight">
            <span className="clrTxt">{`${colourVisibility ? "Colour Copied" : "Light" }`}</span>
            <span className="clrCnt">{clrLight}</span>
          </div>
        </CopyToClipboard>
        <CopyToClipboard text={clrLighter} onCopy={showColour}>
          <div style={{backgroundColor:clrLighter}} className="clrItem clrLighter">
            <span className="clrTxt">{`${colourVisibility ? "Colour Copied" : "Lighter" }`}</span>
            <span className="clrCnt">{clrLighter}</span>
          </div>
        </CopyToClipboard>
        <CopyToClipboard text={clrLightest} onCopy={showColour}> 
          <div style={{backgroundColor:clrLightest, color:clrPrimary}} className="clrItem clrLightest">
            <span className="clrTxt">{`${colourVisibility ? "Colour Copied" : "Lightest" }`}</span>
            <span className="clrCnt">{clrLightest}</span>
          </div>
        </CopyToClipboard>
        </div>
  )
}





